export const handleHighChartsExport = (exportType, chartRef, data) => {
  switch (exportType.id) {
    case 'pdf':
      chartRef.current?.chart?.exportChart(
        {
          type: 'application/pdf',
          filename: data?.title,
          width: 800
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            borderWidth: 2,
            borderColor: '#E0E0E0',
            borderRadius: 16,
            marginTop: 80
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 10,
            y: 0,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 10,
            y: 25,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          exporting: {
            chartOptions: {
              chart: {
                marginTop: 120
              }
            }
          }
        }
      );
      break;

    case 'img':
      chartRef.current?.chart?.exportChart(
        {
          type: 'image/png',
          filename: data?.title
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            borderWidth: 2,
            borderColor: '#E0E0E0',
            borderRadius: 16,
            marginTop: 100
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 10,
            y: 0,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 10,
            y: 25,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          exporting: {
            chartOptions: {
              legend: {
                enabled: true,
                floating: false,
                adjustChartSize: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemMarginTop: 8,
                itemMarginBottom: 8
              },
              chart: {
                marginTop: 120
              }
            }
          }
        }
      );
      break;
    case 'ppt':
      chartRef.current?.chart?.exportChart(
        {
          type: 'application/vnd.openxmlformats-officedocument.pptx',
          filename: data?.title
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            marginTop: 120
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 20,
            y: 40,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 20,
            y: 70,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          exporting: {
            sourceWidth: 800,
            sourceHeight: 600,
            chartOptions: {
              chart: {
                marginTop: 120
              }
            }
          }
        }
      );
      break;

    case 'xls':
      chartRef.current?.chart?.exportChart({ type: 'image/svg+xml' });
      const chart = chartRef.current?.chart;
      const csv = chart?.getCSV();
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${data?.title}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      break;

    default:
      break;
  }
};
